export function SHOW_IN_NETWORK_LOGO(
	carrierQualityEnabled,
	dot,
	isCarrierVettingIntegrationEnabled,
	vettingSource,
	vettingSourceId,
	carrierVettingService,
	carrierId,
	customerCarrier
): boolean {
	if (carrierQualityEnabled) {
		return (
			dot &&
			isCarrierVettingIntegrationEnabled &&
			vettingSourceId &&
			!carrierVettingService.isCarrierOnboarded(carrierId) &&
			customerCarrier &&
			carrierVettingService.isSameVettingSourceAndActiveIntegration(vettingSource) &&
			((isCarrierVettingIntegrationEnabled && vettingSourceId) ||
				!isCarrierVettingIntegrationEnabled)
		);
	}
	return customerCarrier;
}

export function SHOW_ONBOARD_CARRIER_LINK(
	carrierQualityEnabled,
	carrierVettingService,
	vettingSource,
	customerCarrier,
	dot,
	isCarrierVettingIntegrationEnabled,
	vettingSourceId,
	isCarrierOnboarded
) {
	if (carrierQualityEnabled) {
		return dot && isCarrierVettingIntegrationEnabled && !vettingSourceId && !isCarrierOnboarded;
	}
	return showOnboardCarrierLink(
		dot,
		isCarrierVettingIntegrationEnabled,
		carrierVettingService,
		vettingSource,
		isCarrierOnboarded,
		customerCarrier
	);
}

// old logic to render onboard carrier when carrier quality is turned off
function showOnboardCarrierLink(
	dot,
	isCarrierVettingIntegrationEnabled,
	carrierVettingService,
	vettingSource,
	isCarrierOnboarded,
	customerCarrier
): boolean {
	return !customerCarrier && dot && isCarrierVettingIntegrationEnabled && !isCarrierOnboarded;
}
